import(/* webpackMode: "eager", webpackExports: ["GlobalLoading"] */ "/app/src/app/(dynamic-root)/global-loading.js");
;
import(/* webpackMode: "eager", webpackExports: ["RootContainer"] */ "/app/src/app/(dynamic-root)/root.js");
